import React from 'react';
import { TableDataCase } from '../TableDataCase';
import { formatDate } from 'helpers/date/formatDate';
import { Divider } from '../../../../atoms/Dividers/Divider';
import { IS_PROF } from '../../../../../helpers/user/authorization';
import { CommandeDef } from '../../../../../types/commande/commande.def';
import { formatCommandStatus } from 'helpers/commande/formatCommand';

export interface TableDataLineCommandesProps {
  variant?: 'default' | 'warning';
  commande: CommandeDef;
  toCommandeSinglePage: () => void;
  toCommandeUpdatePage: () => void;
}

export const TableDataLineCommandes = ({
  variant = 'default',
  commande,
  toCommandeSinglePage,
  toCommandeUpdatePage
}: TableDataLineCommandesProps) => {
  const caseColor =
    variant === 'default'
      ? commande.client.affilie
        ? 'grey'
        : 'normal'
      : commande.client.affilie
      ? 'orangeOutlinedGrey'
      : 'orangeOutlined';

  const iconCaseColor = variant === 'default' ? 'normal' : 'orangeOutlined';
  return (
    <>
      <tr key={commande?.id}>
        <TableDataCase
          variant={'data'}
          data={commande?.numerocommande}
          color={caseColor}
        />
        <TableDataCase
          variant={'data'}
          data={formatDate(new Date(commande?.createdAt))}
          color={caseColor}
        />
        <TableDataCase
          variant={'data'}
          data={`${commande?.client.prenom}  ${commande?.client.nom}`}
          color={caseColor}
        />
        <TableDataCase
          variant={'data'}
          color={commande?.client.clientpro ? 'green' : 'red'}
          data={commande?.client.clientpro ? 'Oui' : 'Non'}
        />
        <TableDataCase
          variant={'data'}
          data={`${commande.prixTotal} €`}
          color={caseColor}
        />
        <TableDataCase
          variant={'data'}
          data={formatCommandStatus(commande?.status)}
          color={commande?.status === 'PAYE' ? 'green' : 'red'}
        />
        <TableDataCase
          variant={'data'}
          data={
            commande?.livraison?.status?.length
              ? commande.livraison.status
              : 'Information non disponible'
          }
          color={caseColor}
        />
        <TableDataCase
          variant={'data'}
          color={commande?.customerContributedToTheOng ? 'green' : 'red'}
          data={commande?.customerContributedToTheOng ? 'Oui' : 'Non'}
        />
        <TableDataCase
          onClick={toCommandeSinglePage}
          variant={'icon'}
          icon={'MoreAbout'}
          color={iconCaseColor}
        />
        {IS_PROF && (
          <TableDataCase
            onClick={toCommandeUpdatePage}
            variant={'icon'}
            icon={'Edit'}
            color={iconCaseColor}
          />
        )}
      </tr>
      <Divider color={'light'} margin={false} />
    </>
  );
};
